{
  "settings": "Impostazioni",
  "yourDigitalAssistant": "Il tuo assistente digitale",
  "getStarted": "Iniziare",
  "login": "Accesso",
  "loggingIn": "Entrando ...",
  "darkMode": "Dark mode",
  "clearHistory": "Cancellare la storia",
  "historyCleared": "Storia cancellata",
  "changeLanguage": "Lingua",
  "termsAndConditions": "Termini e condizioni",
  "messagePlaceholder": "Scrivi qui il tuo messaggio ...",
  "messagePlaceholderDisabled": "Digitazione disabilitata ...",
  "feedbackTitle": "Valuta la tua esperienza",
  "feedbackPlaceholder": "Dicci cosa ne pensi (facoltativo)",
  "feedbackSend": "Invia",
  "feedbackClose": "Chiudere",
  "sessionExpired": "La sessione è scaduta a causa dell'inattività.",
  "startNewSession": "Inizia una nuova sessione",
  "apiError": "Oops! Qualcosa è andato storto. Stiamo lavorando per risolvere il problema il prima possibile.",
  "apiErrorOffline": "Non sei connesso a Internet.",
  "tryAgain": "Riprova",
  "startOver": "Ricomincia",
  "chatEnded": "La chat è terminata.",
  "chatEndedThankYou": "Grazie per aver chattato con noi!",
  "closeChat": "Vicino",
  "startNewChat": "Chatta di nuovo",
  "humanTakeoverStarted": "Ora stai per essere trasferito al servizio clienti ...",
  "humanTakeoverQueued": "In attesa di connettersi a un agente",
  "humanTakeoverAnAgent": "Un agente",
  "humanTakeoverAgentEntered": "entrato nella conversazione",
  "humanTakeoverAgentLogout": "ha lasciato la conversazione",
  "humanTakeoverTransfer": "Stai per essere trasferito a un nuovo agente",
  "humanTakeoverEnded": "Stai chattando con il tuo assistente digitale",
  "version": "Versione",
  "formIntroText": "Compila il seguente modulo per iniziare a chattare con noi.",
  "formFirstName": "Nome",
  "formLastName": "Cognome",
  "formName": "Nome",
  "formEmail": "E-mail",
  "formWrongEmail": "Fornisci un indirizzo e-mail valido.",
  "formPhone": "Telefono",
  "formShipmentId": "ID spedizione",
  "formQuestion": "La tua domanda",
  "formAccountNumber": "Numero di conto (per clienti aziendali)",
  "formAddress": "Indirizzo",
  "formPostcode": "Codice postale",
  "formCity": "Città",
  "formCountry": "Nazione",
  "formSubmitButton": "Avvia chat",
  "formEmptyFieldError": "Non è consentito essere vuoto.",
  "formPhoneNumberValidationError": "Non un numero di telefono valido.",
  "formInputIsBiggerThan50": "Deve contenere al massimo 50 caratteri.",
  "formInputIsBiggerThan100": "Deve contenere al massimo 100 caratteri.",
  "formInputIsBiggerThan2000": "Deve contenere al massimo 2000 caratteri.",
  "widgetEventOnline": "Messaggio da DA: l'utente è di nuovo online.",
  "widgetEventHidden": "Messaggio da DA : il widget non è visibile.",
  "widgetEventVisible": "Messaggio da DA: il widget è visibile.",
  "widgetEventVisibleMinimized": "Messaggio da DA: il widget è visibile, ma ridotto a icona.",
  "widgetEventMinimized": "Messaggio da DA: il widget è ridotto a icona.",
  "widgetEventMaximized": "Messaggio da DA: il widget è ingrandito.",
  "widgetEventSessionExpired": "Messaggio da DA: sessione widget scaduta.",
  "widgetEventHangupHuman": "Messaggio DA: utente che termina la sessione di acquisizione umana.",
  "widgetEventUserTyping": "Messaggio DA: l'utente sta scrivendo.",
  "fileTooLarge": "Stai tentando di allegare file troppo grandi.",
  "tooManyDiles": "Stai tentando di allegare troppi file.",
  "fileInvalidType": "Stai tentando di allegare tipi di file non validi.",
  "attachmentsDropHere": "Rilascia qui per caricare o",
  "attachmentsBrowse": "Sfoglia file",
  "attachmentsExtenstionQuantity": "pdf o immagini (fino a 10 file)",
  "attachmentsSize": "fino a 30 MB",
  "attachmentsFailedUploading": "Caricamento non riuscito",
  "attachmentsUploading": "Caricamento in corso ...",
  "minimizeExpandText": "Chatta dal vivo con noi ora!",
  "popupWidgetNotificationMessage": "Hai ricevuto un nuovo messaggio!",
  "tabWidgetNotificationMessage": "Nuovo messaggio!",
  "datepickerSendButton": "Inviato"
}
